module.exports = __webpack_public_path__ + "img/retired-2001-party-day.44be1254.jpg";